import { FGInput, FGIcons } from '@fg/design-system';
import React, { useState, useCallback } from 'react';
import { debounce } from 'lodash';

type Props = {
    searchString?: string;
    onSetSearchString?: (value: string) => void;
};
const FeedSeearch = React.memo((props: Props) => {
    const [searchString, setLocalValue] = useState(props.searchString ?? '');
    const debouncedSetSearch = useCallback(
        debounce(props.onSetSearchString, 500),
        []
    );
    const submitSearch = () => {
        debouncedSetSearch.cancel();
        props.onSetSearchString(searchString);
    };

    return (
        <FGInput
            id="search-events-input"
            className="search-events-input"
            value={searchString}
            onChange={e => {
                setLocalValue(e.target.value);
                debouncedSetSearch(e.target.value);
            }}
            onKeyDown={e => {
                if (e.key === 'Enter') {
                    submitSearch();
                }
            }}
            leftElement={
                <FGIcons
                    icon="Search"
                    style={{ cursor: 'pointer' }}
                    onClick={submitSearch}
                />
            }
            autoComplete="off"
            autoFocus
            rightElement={
                searchString && (
                    <FGIcons
                        icon="Close2"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setLocalValue('');
                            debouncedSetSearch.cancel();
                            props.onSetSearchString('');
                        }}
                    />
                )
            }
        />
    );
});

export default FeedSeearch;
